import axios from './axios';

export const addToWaitlist = async (payload, restaurantId) => {
  const response = await axios.post(`/restaurant/${restaurantId}/waitlist`,
    payload,
  );
  return response.data.data;
}

export const fetchWaitlistById = async (waitlistId, restaurantId) => {
  try {
    const response = await axios.get(`/restaurant/${restaurantId}/waitlist/${waitlistId}`);
    return response.data.data;
  } catch(e) {
      console.error(e);
  }
}

export const removeFromWaitlist = async (waitlistId, restaurantId) => {
  try {
    const response = await axios.delete(`/restaurant/${restaurantId}/waitlist/${waitlistId}`);
    return response.data;
  } catch(e) {
      console.error(e);
  }
}

export const getRestaurantByCode = async (code) => {
  const response = await axios.post(`/restaurants/code/${code}`);
  return response.data.data;
}
